import {
	TransferFundOptions,
	NewBeneficiary,
	TransferFunds,
	SavedBeneficiary,
	TransferPinConfirm,
} from './Transfer';
import TransferSuccess from './TransferSuccess';
import TransferFailed from './TransferFailed';
import FundWallet from './FundWallet';
import Withdraw from './Withdraw';
import Wallet from './Wallet';
import WalletExchange from './WalletExchange';
import VirtualCard from './VirtualCard';
import AccountStatement from './AccountStatement';
import BankAccountReq from './BankAccountReq';

export {
	Wallet,
	Withdraw,
	FundWallet,
	TransferSuccess,
	TransferFailed,
	TransferPinConfirm,
	TransferFundOptions,
	TransferFunds,
	SavedBeneficiary,
	NewBeneficiary,
	WalletExchange,
	VirtualCard,
	AccountStatement,
	BankAccountReq
};
